import React from 'react';
import {
  useCustomerContext,
  Provider as CustomerProvider,
} from './customerContext';
import {
  useProductContext,
  Provider as ProductProvider,
} from './productContext';
import { useAuthContext, Provider as AuthProvider } from './authContext';
import { useTaskContext, Provider as TaskProvider } from './taskContext';
import { useCartContext, useCartActions, Provider as CartProvider } from './cartContext';
import { CartStatusProvider, useCartStatus, useProductCartStatus, useCartItem } from './cartStatusContext';
import { useOrdersContext, Provider as OrdersProvider } from './ordersContext';
import { useFilterContext, Provider as FilterProvider } from './filterContext';
import { useEventContext, Provider as EventProvider } from './eventContext';
import {
  OfflineStatusProvider,
  useOfflineStatusContext,
} from './offlineStatusContext';

import {
  useUserFormContext,
  Provider as UserFormProvider,
} from './userFormContext';
import {
  useAbilityContext,
  Provider as AbilityProvider,
} from './abilityContext';

import {
  useLocalForageContext,
  Provider as LocalforageProvider,
} from './localforageContext';

import {
  useCreateTaskContext,
  Provider as CreateTaskProvider,
} from './createTaskContext';
import {
  useOfflineModeContext,
  Provider as OfflineProvider,
} from './offlineContext';
import {
  useClientConfig,
  ClientConfigProvider,
} from './clientConfigContext';
import { message } from 'antd';
import { NotificationsProvider } from '../notifications/context';
import { FieldPhotoProvider } from './fieldPhotoContext';
import CartPriceInquiry from '../components/Cart/CartPriceInquiry';

const ContextProvider = ({ children }) => {
  // Configure global message settings
  message.config({
    maxCount: 5,
    duration: 3,
  });

  return (
    <ClientConfigProvider>
      <AuthProvider>
        <OfflineProvider>
          <OfflineStatusProvider refreshInterval={10000}>
            <LocalforageProvider>
              <CustomerProvider>
                <FieldPhotoProvider>
                <ProductProvider>
                  <OrdersProvider>
                    <FilterProvider>
                      <UserFormProvider>
                        <TaskProvider>
                          <CartProvider>
                            <CartStatusProvider>
                              <CartPriceInquiry />
                              <AbilityProvider>
                                <CreateTaskProvider>
                                  <EventProvider><NotificationsProvider>{children}</NotificationsProvider></EventProvider>
                                </CreateTaskProvider>
                              </AbilityProvider>
                            </CartStatusProvider>
                          </CartProvider>
                        </TaskProvider>
                      </UserFormProvider>
                    </FilterProvider>
                  </OrdersProvider>
                </ProductProvider>
                </FieldPhotoProvider>
              </CustomerProvider>
            </LocalforageProvider>
          </OfflineStatusProvider>
        </OfflineProvider>
      </AuthProvider>
    </ClientConfigProvider>
  );
};

export {
  useTaskContext,
  useOrdersContext,
  useProductContext,
  useCartContext,
  useCartActions,
  useCartItem,
  useCartStatus,
  useProductCartStatus,
  useCustomerContext,
  useAuthContext,
  useFilterContext,
  useUserFormContext,
  useAbilityContext,
  ContextProvider,
  useLocalForageContext,
  useCreateTaskContext,
  useEventContext,
  useOfflineModeContext,
  useOfflineStatusContext,
  useClientConfig,
};
